import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import ShapedButton from './ShapedButton';
import SvgIcon from './SvgIcon';
import SvgShadow from './SvgShadow';

const GoButton = ({ ariaLabel, className, disabled, isEnabled, text, onClick, customTabIndex }) => (
    <ShapedButton
        ariaLabel={ariaLabel}
        styles={classNames('ok-button', className, { disabled, blocked: !isEnabled })}
        text={text}
        onClick={onClick}
        isEnabled={isEnabled}
        customTabIndex={customTabIndex}
    >
        <SvgShadow ariaLabel="Button shadow" type="button" id="ok-button-shadow" />
        <SvgIcon ariaLabel="Ok" class="svg-button lantern-svg" id="ok-button" />
    </ShapedButton>
);

GoButton.propTypes = {
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string,
    isEnabled: PropTypes.bool,
    disabled: PropTypes.bool,
    customTabIndex: PropTypes.string,
};

GoButton.defaultProps = {
    ariaLabel: '',
    text: 'OK',
    className: '',
    isEnabled: true,
    disabled: false,
    customTabIndex: '0',
};

export default GoButton;
